import Vue from 'vue'
import Vuex from 'vuex'
import preference from '@/assets/js/preference.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: null,
    userId: null,
    userInfo: null,
    token: null,
    formInfo: null,
    lotteryInfo: null,
    lotteryItems: null,
    userInfoLastUpdate: 0,
    offsetTop: 0,
    preference: {},
  },
  mutations: {
    // 設定 token (維持登入狀態)
    setToken (state, token) {
      state.token = token
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setFormInfo (state, info) {
      state.formInfo = info
    },
    setLotteryInfo (state, info) {
      state.lotteryInfo = info
    },
    toggleDarkTheme (state, bool) {
      if (bool === true || bool === false) {
        state.preference.isDarkTheme = bool
      } else {
        state.preference.isDarkTheme = !state.preference.isDarkTheme
      }
      preference.set(state.preference)
    },
    clearUser (state) {
      state.userId = null
      state.userInfo = null
    },
    setDebugMode (state, bool = null) {
      state.preference.isDebugMode = bool == null
        ? !state.preference.isDebugMode
        : bool

      preference.set(state.preference)
    },
    setUserInfoLastUpdate (state, _ = +new Date()) {
      state.userInfoLastUpdate = _
    },
    setOnScroll (state) {
      window.onscroll = () => {
        state.offsetTop = window.pageYOffset || document.documentElement.scrollTop
      }
    },
    initPreference (state) {
      state.preference = preference.get()
    },
    setPreference (state, _) {
      state.preference = _
      preference.set(_)
    },
  },
  getters: {
    // 取得學校比賽名稱
    schoolName: state => {
      return state.userInfo ? state.userInfo.name : '樂台計畫'
    },
    // 取得學校 Id
    schoolId: state => {
      return state.userInfo ? state.userInfo.id : null
    },
    // 取得封面背景圖
    cover: state => {
      return state.userInfo ? state.userInfo.coverPhoto : require('@/assets/img/logo/logo-avatar.png')
    },
    // 取得當前屆
    currentPeriod: state => {
      return state.userInfo ? state.userInfo.period : null
    },
    isECPay: state => {
      return state.userInfo && state.userInfo.isECPay
    },
    isDebugMode: state => {
      return state.preference.isDebugMode
    },
    isDarkTheme: state => {
      return state.preference.isDarkTheme
    },
  },
  modules: {
  },
})
